import AdminLayout from "../../components/Layout/AdminLayout";

import "moment/locale/ko";
import { useNavigate, useParams } from "react-router-dom";
import ScheduleExcel from "../../components/ScheduleExcel";

export default function ScheduleDetail() {
  const { date } = useParams();
  const navigate = useNavigate()
  
  const onBackBtn = () => {
    navigate(`/admin/schedule`);
  };

  return (
    <AdminLayout>
      <div className="">
        <div className="flex space-x-5 ">
          <h1
            onClick={onBackBtn}
            className="text-gray-800 font-bold text-2xl cursor-pointer"
          >
            일별 프로그램 관리
          </h1>
          <h1 className="text-gray-800 font-bold text-center mb-5 md:text-left text-2xl">
            -
          </h1>
          <h1 className="text-gray-800 font-bold text-center mb-5 md:text-left text-2xl">
            {date}
          </h1>
        </div>
        <ScheduleExcel/>
      </div>
    </AdminLayout>
  );
}
